import axios from "axios";
import enUS from "ant-design-vue/lib/locale-provider/en_US";
import idID from "ant-design-vue/lib/locale-provider/id_ID";
export default {
  data(){
    return {
      enUS,
      idID
    }
  },
  methods: {
    onChange(e) {
      const { value } = e.target;
      const reg = /^-?(0|[1-9][0-9]*)(\.[0-9]*)?$/;
      if ((!isNaN(value) && reg.test(value)) || value === "" || value === "-") {
        this.value = value;
      }
    },
    onBlur() {
      const { value, onChange } = this;
      if (value.charAt(value.length - 1) === "." || value === "-") {
        onChange({ value: value.slice(0, -1) });
      }
    },
    redirectPandapaKita(context, message) {
      if (
        message === "Invalid API key" ||
        message === "Unauthorized" ||
        message === "Expired API key"
      ) {
        localStorage.removeItem("key_sim_infog");
        window.location = context.$urlPandapaKita;
      }
    },
    ordinalNumber(number) {
      let result = "th";
      this.ordinalnumerik = number.toString();
      if (this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "1") {
        result = "st";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "2"
      ) {
        result = "nd";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "3"
      ) {
        result = "rd";
      } else {
        result = "th";
      }
      return result;
    },
    ordinalNumber(number) {
      let result = "th";
      this.ordinalnumerik = number.toString();
      if (this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "1") {
        result = "st";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "2"
      ) {
        result = "nd";
      } else if (
        this.ordinalnumerik.substr(this.ordinalnumerik.length - 1) == "3"
      ) {
        result = "rd";
      } else {
        result = "th";
      }
      return result;
    },
    load_icon(type){
      let result  = "file";
      if (type=="application/pdf" || type=="pdf"){
        result = "file-pdf";
      } else if(type=="image/jpeg" || type=="jpg" || type=="jpeg"){
        result = "file-image";
      } else if(type=="application/vnd.ms-excel" || type=="xls" || type=="xlsx"){
        result = "file-excel";
      } else if(type=="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
        result = "file-excel";
      } else if(type=="application/msword" || type=="doc" || type=="docx"){
        result = "file-word";
      } else if(type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
        result = "file-word";
      } else if(type=="image/png" || type=="png"){
        result = "file-image";
      } else if(type=="application/zip" || type=="zip"){
        result = "file-zip";
      } else if(type=="application/vnd.rar" || type=="rar"){
        result = "file-zip";
      } 
      return result;
    },
    validRatherThenzero(rule, value, callback) {
      if (value == 0) {
        callback('The value must be rather then 0!');
      }else{
        callback();
      }
    },
    validRatherThenOrSamezero(rule, value, callback) {
      if (value < 0) {
        callback('The value must be rather then 0!');
      }else{
        callback();
      }
    },
    isExistsUrlFile(url) {
      //console.log(url)
      axios({
        method: "get",
        url: url,
      })
        .then((response) => {
          console.log(response)
          return true
        })
        .catch(() => {
          return false;
        });
   },
   onlyNumber (event) {
      //console.log(event); //keyCodes value
      
      let keyCode = (event.keyCode ? event.keyCode : event.which);

      // Detecting Ctrl
      var ctrl = event.ctrlKey ? event.ctrlKey : ((keyCode === 17)
      ? true : false);

      if (((//keyCode < 48 ||  
              keyCode > 57)                   // numeric alphabet
          && (keyCode < 96 || keyCode > 105)  // numeric number
         // && keyCode !== 46 // 46 is backspace
          //&& keyCode !== 8  // 8 is delete
          //&& keyCode !== 9  // 8 is Tab
          && keyCode !== 190  // 8 is titik titik separator dibelakang koma / desimal
          && keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
          && keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
          ) 
          && !( (ctrl && keyCode == 65)   // allow ctrl+A
              || (ctrl && keyCode == 67)  // allow ctrl+C
              || (ctrl && keyCode == 86)) // allow ctrl+V
      ) 
      { 

        event.preventDefault();
        
      }else{
        let desimal = event.target.value.split(".");
        if (desimal.length>1
          && keyCode !== 46 // 46 is backspace
          && keyCode !== 8  // 8 is delete
          && keyCode !== 9  // 8 is Tab
          && keyCode !== 65 // ctrl+A
          ){
          if (desimal[1].length==2){
            event.preventDefault();
          }
        }
      }
    },
    currencyIndonesianFormat (event) {
      //console.log(event); //keyCodes value
      
      let keyCode = (event.keyCode ? event.keyCode : event.which);

      // Detecting Ctrl
      var ctrl = event.ctrlKey ? event.ctrlKey : ((keyCode === 17)
      ? true : false);

      if (((//keyCode < 48 ||  
              keyCode > 57)                   // numeric alphabet
          && (keyCode < 96 || keyCode > 105)  // numeric number
         // && keyCode !== 46 // 46 is backspace
          //&& keyCode !== 8  // 8 is delete
          //&& keyCode !== 9  // 8 is Tab
          //&& keyCode !== 190  // 8 is titik titik separator dibelakang koma / desimal
          //&& keyCode !== 110 // 110 is titik separator dibelakang koma / desimal
          && keyCode !== 188 // String koma
          ) 
          && !( (ctrl && keyCode == 65)   // allow ctrl+A
              || (ctrl && keyCode == 67)  // allow ctrl+C
              || (ctrl && keyCode == 86)) // allow ctrl+V
      ) 
      { 

        event.preventDefault();
        
      }else{
        let desimal = event.target.value.split(",");
        if (desimal.length>1
          && keyCode !== 46 // 46 is backspace
          && keyCode !== 8  // 8 is delete
          && keyCode !== 9  // 8 is Tab
          && keyCode !== 65 // ctrl+A
          ){
          if (desimal[1].length==2){
            event.preventDefault();
          }
        }
      }
    },
    getLocalConfigProvider(value){
      let result = this.enUS;
      if (value=='idID'){
        result = this.idID;
      }
      return result;
    },
    UpperEachWord(value){
      let result = "";
      if (value){
        result = value.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
      }
      return result;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    fileTypeFromUrl(file_nm) {
      let typefile = file_nm.substr(file_nm.lastIndexOf("."));
      typefile = typefile.toLowerCase()
          
      if (typefile == ".xls") {
        typefile = "data:application/vnd.ms-excel;base64,";
      } else if (typefile == ".xlsx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
      } else if (typefile == ".doc") {
        typefile = "data:application/msword;base64,";
      } else if (typefile == ".docx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
      } else if (typefile == ".pdf") {
        typefile = "data:application/pdf;base64,";
      } else if (typefile == ".jpeg" || typefile == ".jpg") {
        typefile = "data:image/jpeg;base64,";
      } else if (typefile == ".png") {
        typefile = "data:image/png;base64,";
      } else if (typefile == ".zip") {
        typefile = "data:application/zip;base64,";
      } else if (typefile == ".rar") {
        typefile = "data:application/rar;base64,";
      } else if (typefile == ".ppt") {
        typefile = "data:application/vnd.ms-powerpoint;base64,";
      } else if (typefile == ".pptx") {
        typefile = "data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,";
      } 
      return typefile
    },
    typeFileFromName(name) {
      return name ? name.substring(name.lastIndexOf(".")+1) : "";
    },
    fileTypeFromUrlBasic(file_nm) {
      let typefile = file_nm.substr(file_nm.lastIndexOf("."));
          
      if (typefile == ".xls") {
        typefile = "application/vnd.ms-excel";
      } else if (typefile == ".xlsx") {
        typefile = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      } else if (typefile == ".doc") {
        typefile = "application/msword";
      } else if (typefile == ".docx") {
        typefile = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      } else if (typefile == ".pdf") {
        typefile = "application/pdf";
      } else if (typefile == ".jpeg" || typefile == ".jpg") {
        typefile = "image/jpeg";
      } else if (typefile == ".png") {
        typefile = "image/png";
      } else if (typefile == ".zip") {
        typefile = "application/zip";
      } else if (typefile == ".rar") {
        typefile = "application/rar";
      } else if (typefile == ".ppt") {
        typefile = "application/vnd.ms-powerpoint";
      } else if (typefile == ".pptx") {
        typefile = "application/vnd.openxmlformats-officedocument.presentationml.presentation";
      } 
      return typefile
    },
    formatterIndonesianCurrency(value){
      let temp = value.replace(',','')
      temp = temp.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      temp = temp.replaceAll('.','e')
      temp = temp.replaceAll(',','.')
      temp = temp.replaceAll('e',',')
      return temp
    },
    parserIndonesianCurrency(value){
      value = value.replaceAll(',','e')
      value = value.replaceAll('.','')
      value = value.replaceAll('e','.')
      return value
    },
    async asyncAxiosGet(url, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "get",
              url: process.env.VUE_APP_SERVICEURL + url,
              params: params,
              auth: auth ? {
                  username: auth.username,
                  password: auth.password,
              } : null,
              headers: auth ?{
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              }: null,
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if(response.length)
                  if (response.data.status == false && response.data.message) {
                    this.displayMessageValue("error-other", response.data.message);
                  } else {
                    let responses = Object.assign({}, err.response.data);
                    this.displayMessageValue("error", responses);
                  }
                reject(err);
              });
          });
    },
    axiosGet(url, auth, params) {
      return new Promise((resolve, reject) => {
          axios({
              method: "get",
              url: process.env.VUE_APP_SERVICEURL + url,
              params: params,
              auth: auth ? {
                  username: auth.username,
                  password: auth.password,
              } : null,
              headers: auth ?{
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              }: null,
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(err);
              });
          });
    },
    async asyncAxiosPost(url, type, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "post",
              url: process.env.VUE_APP_SERVICEURL + url,
              data: params,
              auth: {
                  username: auth.username,
                  password: auth.password,
              },
            headers: type=="formdata" ?
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
              } :
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              } ,
              
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(response);
              });
          });
    },
    async asyncAxiosPut(url, type, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "put",
              url: process.env.VUE_APP_SERVICEURL + url,
              data: params,
              auth: {
                  username: auth.username,
                  password: auth.password,
              },
            headers: type=="formdata" ?
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
              } :
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              } ,
              
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(response);
              });
          });
    },
    async asyncAxiosDelete(url, type, auth, params) {
      return await new Promise((resolve, reject) => {
          axios({
              method: "delete",
              url: process.env.VUE_APP_SERVICEURL + url,
              data: params,
              auth: {
                  username: auth.username,
                  password: auth.password,
              },
            headers: type=="formdata" ?
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": "multipart/form-data",
              } :
              {
                  "X-API-KEY": auth.apikey,
                  "Content-Type": 'application/json',
              } ,
              
          })
              .then(({ data }) => {
                  resolve(data);
              })
            .catch((err) => {
                let response = Object.assign({}, err.response);
                if (response.data.status == false && response.data.message) {
                  this.displayMessageValue("error-other", response.data.message);
                } else {
                  let responses = Object.assign({}, err.response.data);
                  this.displayMessageValue("error", responses);
                }
                reject(response);
              });
          });
    },
  },
};
